import * as XLSX from 'xlsx';

export const TablasResumenDashboard = ({ dashboard, query }) => {
    const totalCantAtencion = (dashboard.porAtencion || []).reduce((acc, curr) => acc + (curr.cantidad || 0), 0);
    const totalCantModulo = (dashboard.porModulo || []).reduce((acc, curr) => acc + (curr.cantidad || 0), 0);
    const totalCantAgente = (dashboard.porAgente || []).reduce((acc, curr) => acc + (curr.cantidad || 0), 0);

    const exportTableToExcel = (data, title, filename) => {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, title);
        XLSX.writeFile(wb, `${filename}_${query.fechaInicio}_${query.fechaFinal}.xlsx`);
    };

    return (
        <div className="row g-4 mb-4">

            {/* 1. TIPOS DE ATENCION */}
            <div className="col-12 col-xl-4">
                <div className="bg-white rounded-4 shadow-sm border overflow-hidden h-100 d-flex flex-column">
                    <div
                        className="p-3 text-white d-flex align-items-center justify-content-between"
                        style={{ background: 'linear-gradient(135deg, #1d6bf3 0%, #1052c5 100%)' }}
                    >
                        <h5 className="fw-bold mb-0 text-white" style={{ fontSize: 16 }}>Tipos de Atención</h5>
                        <button
                            className="btn btn-sm btn-link text-white p-0 opacity-75 opacity-100-hover"
                            title="Exportar esta tabla"
                            onClick={() => exportTableToExcel(
                                (dashboard.porAtencion || []).map(i => ({
                                    Fecha: i.fecha, Servicio: i.servicio || i.tipoAtencion, Cantidad: i.cantidad,
                                    "Prom. Llamado": i.promedioLlamado, "Prom. Atención": i.promedioAtencion
                                })),
                                "TiposAtencion",
                                "Tipos_de_Atencion"
                            )}
                        >
                            <i className="fa-solid fa-file-excel fs-5"></i>
                        </button>
                    </div>

                    <div className="px-3 pt-3 pb-2 text-dark fw-extrabold" style={{ fontSize: 18, color: '#1e293b' }}>
                        TOTAL: {totalCantAtencion}
                    </div>

                    <div className="table-responsive flex-grow-1 px-2" style={{ maxHeight: 380, overflowY: 'auto' }}>
                        <table className="table table-hover align-middle mb-0" style={{ fontSize: 11 }}>
                            <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
                                <tr>
                                    <th style={{ color: '#475569', fontWeight: 700 }}>fecha</th>
                                    <th style={{ color: '#475569', fontWeight: 700 }}>Servicio</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>Cant</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>prom. Llama</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>prom. Atenc</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(dashboard.porAtencion || []).length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-muted">Sin registros</td>
                                    </tr>
                                ) : (
                                    (dashboard.porAtencion || []).map((item, idx) => (
                                        <tr key={idx}>
                                            <td className="text-nowrap text-secondary">{item.fecha}</td>
                                            <td className="fw-bold text-uppercase" style={{ color: '#1e293b' }}>
                                                {item.servicio || item.tipoAtencion}
                                            </td>
                                            <td className="text-center fw-bold">{item.cantidad}</td>
                                            <td className="text-center text-nowrap">{item.promedioLlamado || '00:00:00'}</td>
                                            <td className="text-center text-nowrap">{item.promedioAtencion || '00:00:00'}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-3 bg-light border-top mt-auto" style={{ fontSize: 11 }}>
                        <div className="d-flex justify-content-between mb-1">
                            <span className="fw-bold text-secondary">Total:</span>
                            <span className="fw-extrabold">{totalCantAtencion.toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <span className="fw-bold text-secondary">Tiempo Promedio en Llamado:</span>
                            <span className="fw-bold">{dashboard.resumen?.promedioLlamado || '00:00:00'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span className="fw-bold text-secondary">Tiempo Promedio en Atención:</span>
                            <span className="fw-bold">{dashboard.resumen?.promedioAtencion || '00:00:00'}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 2. ATENCIONES X MODULO */}
            <div className="col-12 col-xl-4">
                <div className="bg-white rounded-4 shadow-sm border overflow-hidden h-100 d-flex flex-column">
                    <div
                        className="p-3 text-white d-flex align-items-center justify-content-between"
                        style={{ background: 'linear-gradient(135deg, #0d8a4f 0%, #086338 100%)' }}
                    >
                        <h5 className="fw-bold mb-0 text-white" style={{ fontSize: 16 }}>Atenciones x Módulo</h5>
                        <button
                            className="btn btn-sm btn-link text-white p-0 opacity-75 opacity-100-hover"
                            title="Exportar esta tabla"
                            onClick={() => exportTableToExcel(
                                (dashboard.porModulo || []).map(i => ({
                                    Fecha: i.fecha, Módulo: i.modulo, Cantidad: i.cantidad,
                                    "Prom. Llamado": i.promedioLlamado, "Prom. Atención": i.promedioAtencion
                                })),
                                "Atenciones_x_Modulo",
                                "Atenciones_x_Modulo"
                            )}
                        >
                            <i className="fa-solid fa-file-excel fs-5"></i>
                        </button>
                    </div>

                    <div className="px-3 pt-3 pb-2 text-dark fw-extrabold" style={{ fontSize: 18, color: '#1e293b' }}>
                        TOTAL: {totalCantModulo}
                    </div>

                    <div className="table-responsive flex-grow-1 px-2" style={{ maxHeight: 380, overflowY: 'auto' }}>
                        <table className="table table-hover align-middle mb-0" style={{ fontSize: 11 }}>
                            <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
                                <tr>
                                    <th style={{ color: '#475569', fontWeight: 700 }}>fecha</th>
                                    <th style={{ color: '#475569', fontWeight: 700 }}>Módulo</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>Cant</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>prom. Llama</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>prom. Atenc</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(dashboard.porModulo || []).length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-muted">Sin registros</td>
                                    </tr>
                                ) : (
                                    (dashboard.porModulo || []).map((item, idx) => (
                                        <tr key={idx}>
                                            <td className="text-nowrap text-secondary">{item.fecha}</td>
                                            <td className="fw-bold text-uppercase" style={{ color: '#1e293b' }}>
                                                {item.modulo}
                                            </td>
                                            <td className="text-center fw-bold">{item.cantidad}</td>
                                            <td className="text-center text-nowrap">{item.promedioLlamado || '00:00:00'}</td>
                                            <td className="text-center text-nowrap">{item.promedioAtencion || '00:00:00'}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-3 bg-light border-top mt-auto" style={{ fontSize: 11 }}>
                        <div className="d-flex justify-content-between mb-1">
                            <span className="fw-bold text-secondary">Total:</span>
                            <span className="fw-extrabold">{totalCantModulo.toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <span className="fw-bold text-secondary">Tiempo Promedio en Llamado:</span>
                            <span className="fw-bold">{dashboard.resumen?.promedioLlamado || '00:00:00'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span className="fw-bold text-secondary">Tiempo Promedio en Atención:</span>
                            <span className="fw-bold">{dashboard.resumen?.promedioAtencion || '00:00:00'}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 3. ATENCIONES X AGENTE */}
            <div className="col-12 col-xl-4">
                <div className="bg-white rounded-4 shadow-sm border overflow-hidden h-100 d-flex flex-column">
                    <div
                        className="p-3 text-white d-flex align-items-center justify-content-between"
                        style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}
                    >
                        <h5 className="fw-bold mb-0 text-white" style={{ fontSize: 16 }}>Atenciones x Agente</h5>
                        <button
                            className="btn btn-sm btn-link text-white p-0 opacity-75 opacity-100-hover"
                            title="Exportar esta tabla"
                            onClick={() => exportTableToExcel(
                                (dashboard.porAgente || []).map(i => ({
                                    Fecha: i.fecha, Agente: i.agente, Cantidad: i.cantidad,
                                    "Prom. Llamado": i.promedioLlamado, "Prom. Atención": i.promedioAtencion
                                })),
                                "Atenciones_x_Agente",
                                "Atenciones_x_Agente"
                            )}
                        >
                            <i className="fa-solid fa-file-excel fs-5"></i>
                        </button>
                    </div>

                    <div className="px-3 pt-3 pb-2 text-dark fw-extrabold" style={{ fontSize: 18, color: '#1e293b' }}>
                        TOTAL: {totalCantAgente}
                    </div>

                    <div className="table-responsive flex-grow-1 px-2" style={{ maxHeight: 380, overflowY: 'auto' }}>
                        <table className="table table-hover align-middle mb-0" style={{ fontSize: 11 }}>
                            <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
                                <tr>
                                    <th style={{ color: '#475569', fontWeight: 700 }}>fecha</th>
                                    <th style={{ color: '#475569', fontWeight: 700 }}>Agente</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>Cant</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>prom. Llama</th>
                                    <th className="text-center" style={{ color: '#475569', fontWeight: 700 }}>prom. Atenc</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(dashboard.porAgente || []).length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-muted">Sin registros</td>
                                    </tr>
                                ) : (
                                    (dashboard.porAgente || []).map((item, idx) => (
                                        <tr key={idx}>
                                            <td className="text-nowrap text-secondary">{item.fecha}</td>
                                            <td className="fw-bold text-uppercase" style={{ color: '#1e293b' }}>
                                                {item.agente}
                                            </td>
                                            <td className="text-center fw-bold">{item.cantidad}</td>
                                            <td className="text-center text-nowrap">{item.promedioLlamado || '00:00:00'}</td>
                                            <td className="text-center text-nowrap">{item.promedioAtencion || '00:00:00'}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-3 bg-light border-top mt-auto" style={{ fontSize: 11 }}>
                        <div className="d-flex justify-content-between mb-1">
                            <span className="fw-bold text-secondary">Total:</span>
                            <span className="fw-extrabold">{totalCantAgente.toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <span className="fw-bold text-secondary">Tiempo Promedio en Llamado:</span>
                            <span className="fw-bold">{dashboard.resumen?.promedioLlamado || '00:00:00'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span className="fw-bold text-secondary">Tiempo Promedio en Atención:</span>
                            <span className="fw-bold">{dashboard.resumen?.promedioAtencion || '00:00:00'}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};
